export enum RoleEnum {
  OWNER = 'main_owner',
  CASES_ADMIN = 'cases_admin',
  CASES_MODERATOR = 'cases_moderator',
  RAFFLE_ADMIN = 'raffle_admin',
  RAFFLE_MODERATOR = 'raffle_moderator',
  SOLITAIRE_MODERATOR = 'solitaire_moderator',
  SOLITAIRE_ADMIN = 'solitaire_admin',
}
